<template>
  <div id="page">
    <b-container>
      <div v-for="(item, index) in orders" :key="index">
        <b-card style="max-width: 20rem;" class="mb-2">

          <b-container class="text-left">
            <b-row style="margin-top: 4px;">
              <b-col>订单号</b-col>
            </b-row>
            <b-row>
              <b-col><b>{{item.orderNo}}</b></b-col>
            </b-row>

            <b-row style="margin-top: 4px;">
              <b-col>订单状态</b-col>
            </b-row>
            <b-row>
              <b-col><b>
                  <font color="red">{{item.orderStatus}}</font>
                </b></b-col>
            </b-row>

            <b-row style="margin-top: 4px;">
              <b-col>申请日期</b-col>
            </b-row>
            <b-row>
              <b-col><b>{{item.orderDateTime}}</b></b-col>
            </b-row>

            <b-row style="margin-top: 8px;">
              <b-col>
                <b-button variant="danger" block @click="itemClick(item)">
                {{item.orderStep == 0 && item.orderStatsNo == 5 ? '支付' : '详情'}}</b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </div>
    </b-container>
  </div>
</template>

<script>
  export default {
    name: 'OrderList',
    data() {
      return {
        projectName: '',
        orders: ''
      }
    },
    methods: {
      itemClick: function(item) {
        var obj = {
          projectName: this.projectName,
          order: item
        }
        var orderItem = JSON.stringify(obj);
          // {
          //   "orderNo": "01251806910893002752",
          //   "orderDateTime": "2020-05-30 17:27:01",
          //   "orderStatus": "未支付",
          //   "orderStatsNo": 5,
          //   "courierCompany": "",
          //   "trackNumber": "",
          //   "orderType": "1",
          //   "price": 1,
          //   "auditFailCause": null,
          //   "modelType": 0,
          //   "modelClass": 0,
          //   "backgroundColor": "201C",
          //   "cardClass": 1,
          //   "address": null,
          //   "orderStep": 0,
          //   "cardTypeName": "借记卡",
          //   "thumbnailFileUrl": null
          // }
          if (item.orderStep == 0 && item.orderStatsNo == 5) {
            //支付页面
            this.toOrderPay(item);
          } else {
            //订单详情
            this.$router.replace({
              name: 'OrderDetails',
              params: {
                orderItem: orderItem
              }
            })
          }
        },
        toOrderPay: function(item) {
          /* {
                 orderNo: '01248790113566597120',
                 orderDateTime: '2020-05-22 09:39:22',
                 price: 1,
                 projectName: 'DIY',
                 thumbnailFileUrl: ''
               } */
          var obj = {
            orderNo: item.orderNo,
            orderDateTime: item.orderDateTime,
            price: item.price,
            projectName: this.projectName,
            thumbnailFileUrl: item.thumbnailFileUrl
          }

          var orderInfo = JSON.stringify(obj);
          this.$router.replace({
            name: 'OrderPay',
            params: {
              orderInfo: orderInfo
            }
          });
        }
      },
      mounted: function() {
        /* {
          "projectName": "DIY",
          "orders": [{
            "orderNo": "01222404618637029376",
            "orderDateTime": "2020-03-10 14:12:50",
            "orderStatus": "制卡完成",
            "orderStatsNo": 8,
            "courierCompany": "",
            "trackNumber": "",
            "orderType": "1",
            "price": 1,
            "auditFailCause": null,
            "modelType": 0,
            "modelClass": 0,
            "backgroundColor": "201C",
            "cardClass": 1,
            "address": "北京市西城区新盛大厦B-8层",
            "orderStep": 3,
            "cardTypeName": "借记卡",
            "thumbnailFileUrl": "group1/M00/00/03/MgAAaF5nL-KAcaymAAHTkobYNwU311.png"
          }]
        } */
        var result = this.$route.params.queryResult;
        console.log('result:' + result);
        var obj = JSON.parse(result);
        this.projectName = obj.projectName
        this.orders = obj.orders;
      }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/OrderList.vue